import { IStatsDesktopResponse } from '../repositories/newbuilding-card/entities/stats/StatsDesktopResponse';
import { IStatsDesktopResponseSchema } from '../repositories/newbuilding-card/entities/stats/StatsDesktopResponseSchema';
import { IRoomStatsResponse } from '../repositories/newbuilding-card/entities/stats/RoomStatsResponse';
import { IRoomStatsResponseSchema } from '../repositories/newbuilding-card/entities/stats/RoomStatsResponseSchema';
import { ILayoutRoom } from '../repositories/newbuilding-card/entities/stats/LayoutRoom';
import { ILayoutRoomSchema } from '../repositories/newbuilding-card/entities/stats/LayoutRoomSchema';

const mapLayoutRoom = (layout: ILayoutRoom): ILayoutRoomSchema => ({
  finishDate: layout.finishDate,
  gaLabel: layout.gaLabel,
  houseName: layout.houseName,
  layoutImageUrl: layout.layoutImageUrl ?? undefined,
  offerId: layout.offerId,
  offerUrl: layout.offerUrl,
  price: layout.price ?? undefined,
  priceDisplay: layout.priceDisplay,
  roomCount: layout.roomCount,
  totalArea: layout.totalArea,
});

const mapRoomStatsResponse = (room: IRoomStatsResponse): IRoomStatsResponseSchema => ({
  fromDeveloperPropsCount: room.fromDeveloperPropsCount,
  fromDeveloperPropsCountDisplay: room.fromDeveloperPropsCountDisplay,
  layouts: room.layouts.map(mapLayoutRoom),
  offersUrl: room.offersUrl,
  price2Range: room.price2Range,
  roomType: room.roomType,
  roomTypeDisplay: room.roomTypeDisplay,
  totalAreaMinDisplay: room.totalAreaMinDisplay,
});

export const mapStatsDesktopResponse = (
  stats: IStatsDesktopResponse | null | undefined,
): IStatsDesktopResponseSchema | null => {
  if (!stats) {
    return null;
  }

  return {
    fromAgentsPropsCountDisplay: stats.fromAgentsPropsCountDisplay,
    fromAgentsPropsCountUrl: stats.fromAgentsPropsCountUrl,
    fromDeveloperMaxPrice: stats.fromDeveloperMaxPrice ?? undefined,
    fromDeveloperMinPrice: stats.fromDeveloperMinPrice ?? undefined,
    fromDeveloperPropsCountDisplay: stats.fromDeveloperPropsCountDisplay,
    fromDeveloperPropsCountUrl: stats.fromDeveloperPropsCountUrl,
    fromDeveloperRooms: stats.fromDeveloperRooms.map(mapRoomStatsResponse),
    propsCountDisplay: stats.propsCountDisplay,
    propsCountUrl: stats.propsCountUrl,
  };
};
